import * as React from 'react';

interface PropsI {
  className?: string;
  withDescription?: boolean;
}

export const HcxLogo: React.FC<PropsI> = ({ className, withDescription }) =>
  !withDescription ? (
    <svg className={className} viewBox="0 0 100 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2053_21143)">
        <path
          d="M0 19.4226V0.333912H3.55556V8.09739H12.3077V0.333912H15.8632V19.4226H12.3077V11.2139H3.55556V19.4226H0Z"
          fill="white"
        />
        <path
          d="M29.1124 19.7565C27.1979 19.7565 25.5568 19.4133 24.1893 18.727C22.84 18.0406 21.8007 16.9739 21.0714 15.527C20.3603 14.0615 20.0047 12.1786 20.0047 9.87826C20.0047 6.52058 20.807 4.03478 22.4115 2.42087C24.0161 0.806957 26.2497 0 29.1124 0C30.6623 0 32.0571 0.268985 33.297 0.806956C34.5551 1.34493 35.5489 2.16116 36.2782 3.25565C37.0258 4.33159 37.3996 5.70435 37.3996 7.37391H33.762C33.762 6.44638 33.5614 5.66725 33.1603 5.03652C32.7774 4.38725 32.2395 3.89565 31.5466 3.56174C30.8537 3.22783 30.0605 3.06087 29.1671 3.06087C27.9272 3.06087 26.897 3.3113 26.0765 3.81217C25.256 4.29449 24.6452 5.01797 24.244 5.98261C23.8611 6.94725 23.6697 8.14377 23.6697 9.57218V10.1843C23.6697 11.6313 23.8611 12.8371 24.244 13.8017C24.6452 14.7664 25.2469 15.4899 26.0491 15.9722C26.8697 16.4545 27.909 16.6957 29.1671 16.6957C30.1152 16.6957 30.9449 16.538 31.656 16.2226C32.3671 15.8887 32.9141 15.4064 33.297 14.7757C33.6981 14.1264 33.8987 13.338 33.8987 12.4104H37.3996C37.3996 14.08 37.0349 15.462 36.3056 16.5565C35.5762 17.6325 34.5825 18.4394 33.3244 18.9774C32.0845 19.4968 30.6805 19.7565 29.1124 19.7565Z"
          fill="white"
        />
        <path
          d="M39.6068 19.4226L46.3624 9.40522L40.2359 0.333912H44.5846L48.7419 6.70609H48.8786L53.0359 0.333912H57.1111L50.9846 9.37739L57.7675 19.4226H53.4462L48.6325 12.0487H48.4684L43.7094 19.4226H39.6068Z"
          fill="#6AD1FF"
        />
        <path
          d="M72.8617 19.7565C71.2936 19.7565 69.9443 19.5061 68.8138 19.0052C67.7016 18.4858 66.8446 17.6603 66.2429 16.5287C65.6412 15.3971 65.3403 13.9316 65.3403 12.1322V0.333912H67.501V12.5774C67.501 14.3397 67.966 15.6568 68.8959 16.5287C69.844 17.4006 71.166 17.8365 72.8617 17.8365C74.5939 17.8365 75.9432 17.4006 76.9096 16.5287C77.8942 15.6568 78.3865 14.3397 78.3865 12.5774V0.333912H80.5198V12.1322C80.5198 13.9316 80.2099 15.3971 79.5899 16.5287C78.9882 17.6603 78.113 18.4858 76.9643 19.0052C75.8338 19.5061 74.4663 19.7565 72.8617 19.7565Z"
          fill="white"
        />
        <path
          d="M92.3175 19.7565C91.3146 19.7565 90.3391 19.6638 89.391 19.4783C88.4428 19.2928 87.6041 18.9774 86.8747 18.5322C86.1454 18.087 85.571 17.5026 85.1517 16.7791C84.7323 16.0557 84.5226 15.1559 84.5226 14.08C84.5226 13.9872 84.5226 13.9038 84.5226 13.8296C84.5226 13.7368 84.5317 13.6441 84.55 13.5513H86.7106C86.7106 13.6255 86.7015 13.7275 86.6833 13.8574C86.6833 13.9872 86.6833 14.0986 86.6833 14.1913C86.6833 15.0075 86.9203 15.6939 87.3944 16.2504C87.8867 16.7884 88.5431 17.1965 89.3636 17.4748C90.2024 17.7345 91.1414 17.8643 92.1807 17.8643C92.5272 17.8643 92.9374 17.8458 93.4115 17.8087C93.9038 17.753 94.3961 17.6603 94.8884 17.5304C95.399 17.382 95.8639 17.1872 96.2833 16.9461C96.7027 16.6864 97.04 16.3617 97.2953 15.9722C97.5688 15.5641 97.7055 15.0632 97.7055 14.4696C97.7055 13.7832 97.5232 13.2174 97.1585 12.7722C96.7938 12.327 96.3106 11.9652 95.7089 11.687C95.1255 11.3901 94.4508 11.1304 93.685 10.9078C92.9192 10.6852 92.1351 10.4719 91.3329 10.2678C90.5306 10.0638 89.7465 9.83189 88.9807 9.57218C88.2331 9.31246 87.5585 8.98783 86.9568 8.59826C86.3551 8.2087 85.8719 7.72638 85.5072 7.1513C85.1608 6.55768 84.9876 5.8342 84.9876 4.98087C84.9876 4.23884 85.1334 3.56174 85.4252 2.94957C85.7169 2.33739 86.1636 1.81797 86.7653 1.3913C87.367 0.946086 88.1329 0.602897 89.0628 0.361738C89.9927 0.120579 91.0958 0 92.3722 0C93.3386 0 94.2411 0.102029 95.0799 0.306086C95.9186 0.510144 96.6571 0.834782 97.2953 1.28C97.9334 1.70667 98.4257 2.25391 98.7722 2.92174C99.1369 3.57101 99.3192 4.35942 99.3192 5.28696V5.62087H97.1859V5.14783C97.1859 4.46145 96.9762 3.88638 96.5568 3.42261C96.1374 2.94029 95.5722 2.56928 94.8611 2.30957C94.1682 2.0313 93.375 1.89217 92.4816 1.89217C91.2599 1.89217 90.2571 2.02203 89.473 2.28174C88.689 2.5229 88.1055 2.86609 87.7226 3.3113C87.3397 3.73797 87.1482 4.22029 87.1482 4.75826C87.1482 5.38899 87.3306 5.91768 87.6953 6.34435C88.0599 6.75246 88.5431 7.09565 89.1448 7.37391C89.7465 7.63362 90.4212 7.87478 91.1688 8.09739C91.9346 8.30145 92.7186 8.50551 93.5209 8.70957C94.3232 8.91362 95.0981 9.15478 95.8457 9.43304C96.6115 9.69275 97.2953 10.0267 97.897 10.4348C98.5169 10.8243 99.0001 11.3159 99.3465 11.9096C99.7112 12.5032 99.8935 13.2359 99.8935 14.1078C99.8935 15.4249 99.5653 16.5009 98.9089 17.3357C98.2708 18.1704 97.3864 18.7826 96.2559 19.1722C95.1255 19.5617 93.8126 19.7565 92.3175 19.7565Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2053_21143">
          <rect width="100" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg className={className} viewBox="0 0 545 233" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4120_33228)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.229 193.673V117.684H42.2416V193.673H0.494629V4.37811H42.2416V79.2846H119.229V4.37811H160.976V193.673H119.229Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M269.472 196.917C213.63 196.917 172.153 153.921 172.153 99.5663V99.025C172.153 45.2116 212.816 1.13275 271.099 1.13275C306.882 1.13275 328.299 13.0313 345.919 30.3378L319.352 60.8966C304.713 47.6455 289.804 39.5323 270.828 39.5323C238.84 39.5323 215.798 66.0334 215.798 98.4849V99.025C215.798 131.475 238.298 158.519 270.828 158.519C292.516 158.519 305.798 149.866 320.708 136.343L347.273 163.114C327.756 183.937 306.069 196.917 269.472 196.917Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4684 232.576V222.675H5.43922V232.576H0V207.911H5.43922V217.672H15.4684V207.911H20.91V232.576H15.4684Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1584 232.963C30.5166 232.963 26.4561 229.264 26.4561 222.005V207.911H31.8953V221.865C31.8953 225.881 33.9076 227.961 37.2279 227.961C40.5494 227.961 42.5617 225.951 42.5617 222.042V207.911H48.0009V221.83C48.0009 229.298 43.799 232.963 37.1584 232.963Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.8681 232.576V216.474L65.9089 227.009H65.7688L58.8802 216.579V232.576H53.5464V207.911H59.4108L65.9089 218.343L72.4082 207.911H78.2714V232.576H72.8681Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.1224 214.254L91.8392 222.252H98.408L95.1224 214.254ZM102.612 232.576L100.351 227.044H89.8964L87.6362 232.576H82.0903L92.6849 207.736H97.7013L108.298 232.576H102.612Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M129.457 232.576L117.484 216.896V232.576H112.114V207.911H117.129L128.715 223.097V207.911H134.083V232.576H129.457Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M162.204 233C154.927 233 149.523 227.397 149.523 220.314V220.244C149.523 213.232 154.82 207.49 162.414 207.49C167.078 207.49 169.868 209.038 172.164 211.294L168.701 215.276C166.795 213.549 164.852 212.492 162.379 212.492C158.211 212.492 155.21 215.946 155.21 220.173V220.244C155.21 224.472 158.141 227.996 162.379 227.996C165.205 227.996 166.935 226.869 168.878 225.108L172.339 228.595C169.796 231.308 166.97 233 162.204 233Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.6 214.254L184.314 222.252H190.885L187.6 214.254ZM195.088 232.576L192.828 227.044H182.372L180.112 232.576H174.566L185.163 207.736H190.177L200.774 232.576H195.088Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M218.648 216.544C218.648 214.113 216.953 212.81 214.234 212.81H210.031V220.35H214.34C217.06 220.35 218.648 218.73 218.648 216.615V216.544ZM214.162 225.177H210.031V232.576H204.592V207.911H214.693C220.591 207.911 224.159 211.4 224.159 216.439V216.51C224.159 222.216 219.708 225.177 214.162 225.177Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.433 232.576H233.873V207.911H228.433V232.576Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M251.25 212.915V232.576H245.812V212.915H238.287V207.911H258.774V212.915H251.25Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M270.675 214.254L267.391 222.252H273.96L270.675 214.254ZM278.165 232.576L275.903 227.044H265.449L263.188 232.576H257.643L268.237 207.736H273.254L283.85 232.576H278.165Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M287.667 232.576V207.911H293.107V227.642H305.432V232.576H287.667Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M320.128 232.576V207.911H338.777V212.74H325.534V217.742H337.189V222.569H325.534V227.75H338.954V232.576H320.128Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M359.231 232.576L353.685 224.12L348.105 232.576H341.925L350.542 220.033L342.277 207.911H348.636L353.827 215.911L359.056 207.911H365.235L356.97 219.962L365.59 232.576H359.231Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M379.469 233C372.193 233 366.79 227.397 366.79 220.314V220.244C366.79 213.232 372.086 207.49 379.68 207.49C384.343 207.49 387.134 209.038 389.429 211.294L385.966 215.276C384.061 213.549 382.118 212.492 379.646 212.492C375.477 212.492 372.476 215.946 372.476 220.173V220.244C372.476 224.472 375.407 227.996 379.646 227.996C382.471 227.996 384.201 226.869 386.145 225.108L389.605 228.595C387.062 231.308 384.237 233 379.469 233Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M409.422 232.576V222.675H399.392V232.576H393.954V207.911H399.392V217.672H409.422V207.911H414.862V232.576H409.422Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M431.712 214.254L428.426 222.252H434.998L431.712 214.254ZM439.201 232.576L436.94 227.044H426.485L424.225 232.576H418.679L429.276 207.736H434.29L444.887 232.576H439.201Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M466.046 232.576L454.071 216.896V232.576H448.704V207.911H453.718L465.303 223.097V207.911H470.672V232.576H466.046Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M488.513 233C480.811 233 475.514 227.608 475.514 220.314V220.244C475.514 213.232 480.988 207.49 488.478 207.49C492.927 207.49 495.612 208.687 498.19 210.872L494.764 214.994C492.856 213.409 491.161 212.492 488.301 212.492C484.344 212.492 481.201 215.98 481.201 220.173V220.244C481.201 224.753 484.31 228.066 488.688 228.066C490.666 228.066 492.433 227.572 493.809 226.587V223.062H488.335V218.377H499.073V229.088C496.53 231.236 493.033 233 488.513 233Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M504.301 232.576V207.911H522.951V212.74H509.707V217.742H521.363V222.569H509.707V227.75H523.128V232.576H504.301Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M531.107 186.296V193.667H529.067V186.296H526.246V184.419H533.928V186.296H531.107Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M542.733 193.667V187.63L540.124 191.58H540.07L537.489 187.669V193.667H535.488V184.419H537.686L540.124 188.331L542.56 184.419H544.759V193.667H542.733Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M518.85 4.45578L518.596 4.37811H505.922L373.959 193.667L373.955 193.673H386.937L386.94 193.667L518.85 4.45578Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M485.499 26.7137H472.516L356.126 193.667L356.122 193.673H369.104L369.107 193.667L485.499 26.7137Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M474.032 17.5777H461.05L338.29 193.667L351.268 193.673L351.271 193.667L474.032 17.5777Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M426.969 59.4999L391.187 4.37811H342.391L403.214 93.5741L426.969 59.4999Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M457.205 99.8471L433.389 134.008L472.515 193.673H521.31L457.205 99.8471Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4120_33228">
          <rect width="545" height="233" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
